import {palette} from "./constants";

const LETTER_DELAYS = {
  b: "1.25s",
  o: "1.40s",
  u: "1.55s",
  c: "2.35s",
  e: "2.50s",
};

export const SplashTextOverlay = ({playing}: {playing: boolean}) => (
  <div
    style={{
      position: "absolute",
      left: 0,
      right: 0,
      top: "45%",
      zIndex: 6,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      pointerEvents: "none",
      userSelect: "none",
    }}
  >
    <svg
      viewBox="0 0 710 148"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="bounce"
      style={{
        width: "clamp(150px, 44vw, 232px)",
        height: "auto",
        color: palette.mark,
        filter: "drop-shadow(0 1px 18px rgba(255,255,255,0.55))",
      }}
    >
      <defs>
        <mask id="nmask" maskUnits="userSpaceOnUse" x="285" y="-20" width="345" height="185">
          <path
            d="M307 145 A84 84 0 0 1 475 145 A136 136 0 0 1 611 9"
            pathLength={1}
            fill="none"
            stroke="#ffffff"
            strokeWidth={30}
            strokeLinecap="round"
            style={{
              strokeDasharray: 1,
              strokeDashoffset: 1,
              ...(playing && {animation: "nDraw 1.15s cubic-bezier(0.45, 0, 0.3, 1) 1.7s forwards"}),
            }}
          />
        </mask>
      </defs>
      {/* n — drawn via stroke mask */}
      <path
        mask="url(#nmask)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M611.047 18C540.907 18 484.047 74.8602 484.047 145H466.047C466.047 103.579 432.468 70.0004 391.047 70.0004C349.626 70.0004 316.047 103.579 316.047 145H298.047C298.047 93.6379 339.684 52.0004 391.047 52.0004C426.418 52.0004 457.177 71.7467 472.902 100.817C491.588 42.3421 546.373 0 611.047 0V18Z"
        fill="currentColor"
      />
      {/* b */}
      <path
        style={{
          transform: "translateY(130px)",
          ...(playing && {animation: `letterRise 1.4s cubic-bezier(0.3, 0.6, 0.35, 1) ${LETTER_DELAYS.b} both`}),
        }}
        d="M47.232 54.3081C74.128 54.3081 93.316 74.1521 93.316 100.884C93.316 127.288 74.128 147.296 47.232 147.296C34.932 147.296 23.944 142.704 16.072 134.996L13.776 145.164H0V24.7881H18.204V64.6401C25.912 58.0801 35.916 54.3081 47.232 54.3081ZM45.92 129.748C62.648 129.748 74.784 117.448 74.784 100.72C74.784 84.1561 62.648 71.6921 45.92 71.6921C29.192 71.6921 16.892 84.1561 16.892 100.72C16.892 117.284 29.192 129.748 45.92 129.748Z"
        fill="currentColor"
      />
      {/* o */}
      <path
        style={{
          transform: "translateY(130px)",
          ...(playing && {animation: `letterRise 1.4s cubic-bezier(0.3, 0.6, 0.35, 1) ${LETTER_DELAYS.o} both`}),
        }}
        d="M148.826 147.296C121.602 147.296 101.43 127.452 101.43 100.72C101.43 73.9881 121.602 54.3081 148.826 54.3081C175.886 54.3081 196.058 74.1521 196.058 100.72C196.058 127.452 175.886 147.296 148.826 147.296ZM148.826 129.912C165.554 129.912 177.526 117.776 177.526 100.72C177.526 83.8281 165.554 71.6921 148.826 71.6921C131.934 71.6921 119.962 83.8281 119.962 100.72C119.962 117.776 131.934 129.912 148.826 129.912Z"
        fill="currentColor"
      />
      {/* u */}
      <path
        style={{
          transform: "translateY(130px)",
          ...(playing && {animation: `letterRise 1.4s cubic-bezier(0.3, 0.6, 0.35, 1) ${LETTER_DELAYS.u} both`}),
        }}
        d="M249.563 147.296C225.127 147.296 209.219 131.552 209.219 107.608V56.4401H227.423V105.148C227.423 120.564 235.787 129.912 249.563 129.912C263.339 129.912 271.539 120.4 271.539 105.148V56.4401H289.743V107.608C289.743 131.552 273.999 147.296 249.563 147.296Z"
        fill="currentColor"
      />
      {/* c */}
      <path
        style={{
          transform: "translateY(130px)",
          ...(playing && {animation: `letterRise 1.4s cubic-bezier(0.3, 0.6, 0.35, 1) ${LETTER_DELAYS.c} both`}),
        }}
        d="M567.852 147.296C541.448 147.296 521.44 127.124 521.44 100.72C521.44 74.3161 541.448 54.3081 567.852 54.3081C589.828 54.3081 606.884 67.7561 611.804 88.0921H593.764C589.172 77.9241 579.332 71.6921 567.852 71.6921C551.944 71.6921 539.972 84.3201 539.972 100.72C539.972 117.12 552.108 129.912 567.852 129.912C579.496 129.912 588.844 123.68 593.6 112.856H611.968C607.212 133.52 589.664 147.296 567.852 147.296Z"
        fill="currentColor"
      />
      {/* e */}
      <path
        style={{
          transform: "translateY(130px)",
          ...(playing && {animation: `letterRise 1.4s cubic-bezier(0.3, 0.6, 0.35, 1) ${LETTER_DELAYS.e} both`}),
        }}
        d="M709.232 101.048C709.232 103.016 709.068 104.984 708.74 106.952H636.908C639.204 121.384 649.536 130.24 663.968 130.24C674.628 130.24 683.156 125.32 687.912 117.12H707.1C700.048 135.816 683.812 147.296 663.968 147.296C638.056 147.296 618.54 127.288 618.54 100.72C618.54 74.3161 638.056 54.3081 663.968 54.3081C691.192 54.3081 709.232 75.3001 709.232 101.048ZM663.968 70.8721C650.356 70.8721 640.352 79.0721 637.4 92.1921H690.864C687.584 78.7441 677.58 70.8721 663.968 70.8721Z"
        fill="currentColor"
      />
    </svg>
  </div>
);
